import { Link, Outlet, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import Swal from "sweetalert2";
import "./admin.css";
import "./AdminLayout.css";

const NAV_ITEMS = [
  { to: "/admin/dashboard", icon: "", label: "Dashboard" },
  { to: "/admin/bikes", icon: "", label: "Manage Bikes" },
  { to: "/admin/add-bike", icon: "", label: "Add Bike" },
  { to: "/admin/bookings", icon: "", label: "Bookings" },
  { to: "/admin/users", icon: "", label: "Users" },
  { to: "/admin/price-overrides", icon: "", label: "Price Overrides" },
];

function AdminLayout() {
  const navigate = useNavigate();
  const location = useLocation();
  const { logout } = useAuth();

  const handleLogout = async () => {
    const result = await Swal.fire({
      title: "Logout",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, Logout",
      customClass: {
        popup: "logout-popup",
      },

      background: "transparent",

      backdrop: `
        rgba(0,0,0,0.4)
      `,
    });

    if (result.isConfirmed) {
      logout();
      navigate("/");
    }
  };

  return (
    <div className="admin-shell">
      {/* ── SIDEBAR ── */}
      <aside className="admin-sidebar">
        <div className="admin-sidebar-brand">
          <div><img src="/logo.jpeg" alt="Logo" className="logo-img" /></div>
          <div>
            <h2>Bro's Bikes</h2>
            <span>Admin Panel</span>
          </div>
        </div>

        <nav className="admin-nav">
          {NAV_ITEMS.map((item) => (
            <Link
              key={item.to}
              to={item.to}
              className={location.pathname === item.to ? "active" : ""}
            >
              <span className="nav-icon">{item.icon}</span>
              {item.label}
            </Link>
          ))}
        </nav>

        <div className="admin-sidebar-footer">
          <button className="admin-logout-btn" onClick={handleLogout}>
            Logout
          </button>
        </div>
      </aside>

      {/* ── CONTENT ── */}
      <main className="admin-main">
        <Outlet />
      </main>
    </div>
  );
}

export default AdminLayout;
